import React from 'react';

export default function AuroraShawlSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="auroraGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#69F0AE" />
          <stop offset="40%" stopColor="#40C4FF" />
          <stop offset="75%" stopColor="#7C4DFF" />
          <stop offset="100%" stopColor="#B388FF" />
        </linearGradient>
        <linearGradient id="auroraShine" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="white" stopOpacity="0.35" />
          <stop offset="100%" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
      {/* Main flowing shawl */}
      <path d="M10 8 C8 18 6 28 8 36 C12 32 16 34 20 32 C24 34 28 32 32 36 C34 28 32 18 30 8 Z" fill="url(#auroraGrad)" />
      {/* Top shine */}
      <path d="M10 8 C8 18 6 28 8 36 C12 32 16 34 20 32 C24 34 28 32 32 36 C34 28 32 18 30 8 Z" fill="url(#auroraShine)" />
      {/* Ribbon flow lines */}
      <path d="M12 12 C10 20 9 28 11 34" stroke="#B9F6CA" strokeWidth="0.8" fill="none" opacity="0.6" />
      <path d="M20 10 C19 20 19 28 20 32" stroke="#80D8FF" strokeWidth="0.8" fill="none" opacity="0.5" />
      <path d="M28 12 C30 20 31 28 29 34" stroke="#B388FF" strokeWidth="0.8" fill="none" opacity="0.6" />
      {/* Collar around neck */}
      <ellipse cx="20" cy="9" rx="9" ry="2.5" fill="#4A148C" opacity="0.7" />
      <ellipse cx="20" cy="8.5" rx="8" ry="1.5" fill="#7C4DFF" />
      {/* Aurora star specks */}
      <circle cx="14" cy="20" r="0.5" fill="white" opacity="0.8" />
      <circle cx="26" cy="24" r="0.5" fill="white" opacity="0.7" />
      <circle cx="20" cy="28" r="0.4" fill="white" opacity="0.8" />
    </svg>
  );
}
